import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchSeason } from "@/lib/api";

const SeasonCtx = createContext({ id: "winter", accent: "#B6A27A", label: "" });

export function SeasonProvider({ children }) {
  const [season, setSeason] = useState({ id: "winter", accent: "#B6A27A", label: "" });

  useEffect(() => {
    (async () => {
      try {
        const s = await fetchSeason();
        setSeason(s);
        document.documentElement.style.setProperty("--season-accent", s.accent);
      } catch (e) {
        console.error("season fetch failed", e);
      }
    })();
  }, []);

  return <SeasonCtx.Provider value={season}>{children}</SeasonCtx.Provider>;
}

export function useSeason() {
  return useContext(SeasonCtx);
}
